var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueMarkdown',{staticClass:"item-markdown",attrs:{"source":_vm.description,"linkify":false,"html":_vm.isDescriptionHtmlStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }